export const getAppId = ({ domain = '' }: {
	domain?: string;
}): string => {
	if (domain.indexOf('.dev.teaches.cc') > -1) {
		return '2836417839968847';
	}
	if (domain.indexOf('.staging.teaches.cc') > -1) {
		return '2008399435970652';
	}
	return '273347407208654';
};
